export const UID = 'UID';
export const ERROR_STATE = 'ERROR_STATE';
export const IS_AUTH = 'IS_AUTH';
export const MENUS = 'MENUS';
export const LOCALE = 'LOCALE';
export const PARAMS = 'PARAMS';
export const GMT = 'GMT';
export const USER_ETC_INFOS = 'USER_ETC_INFOS';



// WEBPACK FOOTER //
// ./src/vuex/mutation_types.js